import { render, staticRenderFns } from "./NewPropertyDialog.vue?vue&type=template&id=49bb30e6"
import script from "./NewPropertyDialog.vue?vue&type=script&lang=js"
export * from "./NewPropertyDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports